module.exports = __webpack_public_path__ + "img/huereaffmarker.526563f6.png";